// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.plan-selector {
  width: 26vw;
  height: 73vh;
  border: 1px solid #DADADA;
  border-radius: 15px;
  padding: 2vw;
}
.plan-selector__content {
  display: flex;
  flex-direction: column;
  gap: 1.8vw;
}
.plan-selector__content__header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.plan-selector__content__header__icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2vw;
  height: 2vw;
  border-radius: 50%;
  box-shadow: 0px 0px 10px 0px #DADADA;
}
.plan-selector__content__header__chip {
  visibility: hidden;
  background-color: #EDEDFF;
  color: #4F4BFF;
}
.plan-selector__content__title {
  font-weight: bold;
  font-size: 1.5rem;
}
.plan-selector__content__description {
  font-size: 1rem;
  color: #7D7D7D;
}
.plan-selector__content__price {
  display: flex;
  flex-direction: row;
  align-items: last baseline;
  gap: 10px;
}
.plan-selector__content__price__number {
  font-size: 3rem;
  font-weight: bold;
}
.plan-selector__content__price__month {
  font-size: 1rem;
  color: #62718C;
}
.plan-selector__content__separator {
  border-top: 1px solid #DADADA;
}
.plan-selector__content__details {
  display: flex;
  flex-direction: column;
  height: 18vh;
  gap: 1vw;
}
.plan-selector__content__details__detail {
  display: flex;
  flex-direction: row;
  gap: 1vw;
}
.plan-selector__content__details__detail::before {
  content: "✓";
}
.plan-selector__content__button {
  color: #4D5E74;
  font-weight: bold;
  padding: 1vw;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.3s;
  border: 1px solid #EDF0F5;
}
.plan-selector .popular-background {
  background-color: #4F4BFF !important;
  color: white !important;
}

.popular-border {
  border: 2px solid #4F4BFF !important;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/payment/payment.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,WAAA;EACA,YAAA;EAEA,yBAAA;EACA,mBAAA;EACA,YAAA;AACJ;AAAI;EACI,aAAA;EACA,sBAAA;EACA,UAAA;AAER;AADQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AAGZ;AAFY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;AAIhB;AAFY;EACI,kBAAA;EACA,yBAAA;EACA,cAAA;AAIhB;AADQ;EACI,iBAAA;EACA,iBAAA;AAGZ;AADQ;EACI,eAAA;EACA,cAAA;AAGZ;AADQ;EACI,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,SAAA;AAGZ;AAFY;EACI,eAAA;EACA,iBAAA;AAIhB;AAFY;EACI,eAAA;EACA,cAAA;AAIhB;AADQ;EACI,6BAAA;AAGZ;AAAQ;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,QAAA;AAEZ;AADY;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AAGhB;AAFgB;EACI,YAAA;AAIpB;AAAQ;EACI,cAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iCAAA;EACA,yBAAA;AAEZ;AACI;EACI,oCAAA;EACA,uBAAA;AACR;;AAEA;EACI,oCAAA;AACJ","sourcesContent":[".plan-selector{\n    width: 26vw;\n    height: 73vh;\n\n    border: 1px solid #DADADA;\n    border-radius: 15px;\n    padding: 2vw;\n    &__content{\n        display: flex;\n        flex-direction: column;\n        gap: 1.8vw;\n        &__header{\n            display: flex;\n            flex-direction: row;\n            justify-content: space-between;\n            &__icon{\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                width: 2vw;\n                height: 2vw;\n                border-radius: 50%;\n                box-shadow: 0px 0px 10px 0px #DADADA;\n            }\n            &__chip{\n                visibility: hidden;\n                background-color: #EDEDFF;\n                color: #4F4BFF;\n            }\n        }\n        &__title{\n            font-weight: bold;\n            font-size: 1.5rem;\n        }\n        &__description{\n            font-size: 1rem;\n            color: #7D7D7D;\n        }\n        &__price{\n            display: flex;\n            flex-direction: row;\n            align-items: last baseline;\n            gap:10px;\n            &__number{\n                font-size: 3rem;\n                font-weight: bold;\n            }\n            &__month{\n                font-size: 1rem;\n                color: #62718C;\n            }\n        }\n        &__separator{\n            border-top: 1px solid #DADADA;\n        }\n\n        &__details{\n            display: flex;\n            flex-direction: column;\n            height: 18vh;\n            gap: 1vw;\n            &__detail{\n                display: flex;\n                flex-direction: row;\n                gap: 1vw;\n                &::before{\n                    content: '\\2713';\n                }\n            }\n        }\n        &__button{\n            color: #4D5E74;\n            font-weight: bold;\n            padding: 1vw;\n            border-radius: 10px;\n            text-align: center;\n            cursor: pointer;\n            transition: background-color 0.3s;\n            border: 1px solid #EDF0F5;\n        }\n    }\n    .popular-background{\n        background-color: #4F4BFF !important;\n        color: white !important;\n    }\n}\n.popular-border{\n    border: 2px solid #4F4BFF !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
